import { render, staticRenderFns } from "./index.m.vue?vue&type=template&id=0b43cd64&scoped=true"
import script from "./index.m.vue?vue&type=script&lang=js"
export * from "./index.m.vue?vue&type=script&lang=js"
import style0 from "./index.m.vue?vue&type=style&index=0&id=0b43cd64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b43cd64",
  null
  
)

export default component.exports